import { SwitchProps } from 'antd/es/switch';
import React, { FC } from 'react';
import { Switch } from 'components/atoms/switch/switch';

export const CsatStatus: FC<SwitchProps> = (props) => (
  <Switch size="small" onClick={(_, e) => e.stopPropagation()} {...props} />
);
